import React from "react";
import { observer } from "mobx-react";
import { MusicalWorkLinkViewStore } from "../../store";
import { MusicalWorkLinkViewForm } from "./MusicalWorkLinkViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type MusicalWorkLinkViewProps = {
  musicalWorkLinkViewStore: MusicalWorkLinkViewStore;
};

export const MusicalWorkLinkView: React.FC<MusicalWorkLinkViewProps> = observer(
  ({ musicalWorkLinkViewStore }) => {
    return (
      <div>
        <MusicalWorkLinkViewForm
          url={musicalWorkLinkViewStore.urlValue}
          platformValue={musicalWorkLinkViewStore.platformValue}
          typeValue={musicalWorkLinkViewStore.typeValue}
          onPrint={(handlePrint: () => void) =>
            musicalWorkLinkViewStore.printMusicalWorkLink(handlePrint)
          }
          onCancel={() => musicalWorkLinkViewStore.cancelMusicalWorkLink()}
          onEdit={
            musicalWorkLinkViewStore.isEditEnabled
              ? () => musicalWorkLinkViewStore.editMusicalWorkLink()
              : undefined
          }
        />
        <ErrorDialog
          open={musicalWorkLinkViewStore.errorDialogOpened}
          title={musicalWorkLinkViewStore.errorTitle}
          description={musicalWorkLinkViewStore.errorDescription}
          onClose={() => musicalWorkLinkViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
